let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Hwnt")).then(() => parcelRequire('3tEJH'));